<div [style.color]="color ? color : 'inherit'" [style.border-color]="color ? color : 'inherit'" class="py-1">
  {{ value }}
</div>
